<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Label_AuditLogs') }}</h2>
    </header>

    <article class="view__content">

      <div class="view__panel">
        <div class="form js-form">
          <submenu></submenu>

          <list class="view__content"
            :data="entries()"
            :fields="headers()"
            :pagination="pagination"
            @paginate="paginate" />
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import L from 'services/Localization'
import List from 'components/layout/list'
import Submenu from 'components/views/members/Submenu'
import { mapGetters } from 'vuex'
import listHelpers from 'mixins/list-helpers'

export default {
  name: 'member-audit-logs',
  components: { List, Submenu },
  mixins: [listHelpers],
  data() {
    return {
      L: L
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getMemberAuditLogs', this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters({
      auditLogs: 'auditLogs',
      pagination: 'auditLogsPagination'
    })
  },
  methods: {
    paginate(pageNumber) {
      this.$store.dispatch('getMemberAuditLogs', {
        page: pageNumber
      })
    },
    entries: function() {
      return this.auditLogs
    },
    headers: function() {
      let headers = [
        { prop: 'action', label: L.localize('Label_AuditLogs_Action') },
        { prop: 'field', label: L.localize('Label_AuditLogs_Field') },
        { prop: 'oldValue', label: L.localize('Label_AuditLogs_OldValue') },
        { prop: 'newValue', label: L.localize('Label_AuditLogs_NewValue') },
        { prop: 'actionDate', label: L.localize('Label_AuditLogs_ActionDate'), transform: this.showDate },
        { prop: 'actor.emailAddress', label: L.localize('Label_AuditLogs_Actor') }
      ]
      return headers
    }
  }
}
</script>



// WEBPACK FOOTER //
// MemberAuditLogs.vue?2fa1d9ec